export default  process.env.REACT_APP_BACKEND_URL || 'http://localhost:3000';



// WEBPACK FOOTER //
// ./src/utils/apiBaseUrl.js